import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { Button } from "semantic-ui-react";
import API from 'libs/api';
import TABLE from '../../../../../components/cmp_table/cmp_table'

import CMP_NOTE_CREATE from "../cmp_note_create/cmp_note_create";
import CMP_NOTE_UPDATE from "../cmp_note_udpate/cmp_note_update";

import './crd_notes_list.css';



export default function CRD_NOTES_LIST() {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    //  data table variables
    const [ var_data, set_data ] = useState([]);
    const [ var_data_settings, set_data_settings ] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'lastmodified',
        sortorder: 'desc'
    });
    const [ var_totalrows, set_totalrows ] = useState(0);

    //  data ready variables
    const [ var_ready, set_ready ] = useState(false);
    const [ var_processing, set_processing ] = useState('inactive');

    const [ var_note_create_open, set_note_create_open ] = useState(false);
    const [ var_note_update_open, set_note_update_open ] = useState(false);
    const [ var_note_update_id, set_note_update_id ] = useState(false);


    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        get_notes(var_data_settings);
    }, [])



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_notes(data_settings) {

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_notes(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            set_data(results.results === undefined ? [] : results.results);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
            console.log(e);
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_notes(settings){
        let var_parameters = {queryStringParameters: settings};
        return API.get('admin-providers', '/get-provider-notes/' + provider_id, var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_details(note_id){
        set_note_update_id(note_id);
        set_note_update_open(true);
    }

    function onClick_create(){
        set_note_create_open(true);
    }

    // RENDER CONTAINER ================================================================================================

    return (

        <div id='crd_notes_list' className='card'>
            <div className='card__header'>
                <div className='text--md bold'>Notes</div>
                <div className='card__header__totalrows text--md bold'>{var_totalrows}</div>
            </div>
            <div className='card__content'>

                <div className='card__header__buttons'>
                    {/*<Button className='primary' onClick={onClick_create}>Add a new note</Button>*/}
                </div>

                <TABLE
                    var_data_settings={var_data_settings}
                    set_data_settings={set_data_settings}
                    onChange={get_notes}
                    processing={var_processing}
                    totalrows={var_totalrows}
                >
                    <headers>
                        <header sortby='lastmodified'>Modified</header>
                        <header sortby='category'>Category</header>
                        <header sortby='note'>Note</header>
                        <header sortby='lastmodifiedby'>Modified by</header>
                    </headers>
                    <data>
                        {var_data && var_data.map(item =>
                            <row key={item.id} onClick={()=>onClick_details(item.id)}>
                                <cell>{item.lastmodified}</cell>
                                <cell>{item.category}</cell>
                                <cell>{item.note}</cell>
                                <cell>{item.lastmodifiedby}</cell>
                            </row>
                        )}
                    </data>
                </TABLE>

            </div>

            <CMP_NOTE_CREATE
                onOpen={var_note_create_open}
                onClose={() => set_note_create_open(false)}
                onRefresh={get_notes}
            />

            <CMP_NOTE_UPDATE
                id={var_note_update_id}
                onOpen={var_note_update_open}
                onClose={() => set_note_update_open(false)}
                onRefresh={get_notes}
            />

        </div>

    )
}